import { createSelector } from 'reselect';
import { format, utcToZonedTime } from 'date-fns-tz';

const getIsLoading = (state) => state.loading?.isLoading;
const getIsWarmup = (state) => state.gumbo?.gameData?.status?.extendedStatus?.isWarmup;
const getFirstPitch = (state) => state?.gumbo?.gameData?.gameInfo?.firstPitch;
const getVenue = (state) => state.gumbo?.gameData?.venue;
const getVenueName = (state) => getVenue(state)?.name;
const getVenueTz = (state) => getVenue(state)?.timeZone?.id || 'America/New_York';

const getFirstPitchTime = (firstPitch, timeZone) => (
    firstPitch ?
        format(utcToZonedTime(firstPitch, timeZone),"h:mm a zzz", { timeZone }) :
        ''
);

export const getFirstPitchState = createSelector(
    [getFirstPitch, getIsLoading, getIsWarmup, getVenueTz, getVenueName],
    (firstPitch, isLoading, isWarmup, tz, venueName) => {
        const formattedDate = getFirstPitchTime(firstPitch, tz);
        return {
            firstPitchTime: formattedDate,
            isLoading,
            isWarmup,
            venueName
        };
    }
);
